import { HttpErrorResponse } from '@angular/common/http';

interface ApiErrorResponse {
  errored?: boolean;
  errorMessage?: string | null;
  errors?: string[] | null;
}

/**
 * Extrae el mensaje de error de una respuesta API envuelta.
 * Retorna null si la respuesta no tiene errores.
 */
export function extractApiError(response: ApiErrorResponse): string | null {
  if (!response.errored) return null;
  const details = response.errors?.length
    ? `\n${response.errors.join('\n')}`
    : '';
  return `${response.errorMessage ?? 'Error desconocido'}${details}`;
}

/**
 * Extrae un mensaje legible de cualquier tipo de error HTTP.
 * Soporta HttpErrorResponse, Error, y objetos con shape de API response.
 */
export function extractHttpError(error: unknown, fallback = 'Error inesperado'): string {
  if (error instanceof HttpErrorResponse) {
    const body = error.error as ApiErrorResponse | undefined;
    if (body?.errorMessage) {
      const details = body.errors?.length ? `\n${body.errors.join('\n')}` : '';
      return `${body.errorMessage}${details}`;
    }
    return error.message ?? fallback;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error !== null) {
    const obj = error as Record<string, unknown>;
    if (typeof obj['errorMessage'] === 'string') return obj['errorMessage'];
    if (typeof obj['message'] === 'string') return obj['message'];
  }

  return fallback;
}
